/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import * as Actions from "actions";
import {
    TextField, Button, IconButton, Container, Typography, Box, Grid, MenuItem, Modal, Backdrop, Fade,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import UserProductItem from "components/elements/user/products/UserProductItem";
import UserProductDetail from "components/elements/user/products/UserProductDetail";
import UserProductDetailModal from "components/elements/user/products/UserProductDetailModal";
import MockSearchResults from "components/elements/main/MockSearchResults";

import {H5} from "components/CustomTypography";
import {SearchOutlinedIcon} from "../UserCombinedSearch";

import {
    getCategoryBreadcrum,
    getUserProductSortList,
    getCategoryFromID,
    getLocationMarketFromID,
    getLocationBreadcrum,
    isMarketPlaceOnly,
    isFeatureSupported, getLogo, getPlatform, analyticsTrackPageView, analyticsTrackEvent, getURI
} from "helpers/utils";
import CustomSectionCreator from "components/CustomSectionCreator";
import MobileCategoryNav from "components/mobile-category-nav";
import UserProductCategorySlider from "components/elements/user/products/UserProductCategorySlider";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import UserShopLocationSlider from "components/elements/user/UserShopLocationSlider";
import CustomFlexBox from "components/CustomFlexBox";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import {useLocation} from "react-router-dom";
import UserProductStatusSelector from "components/elements/user/products/UserProductStatusSelector";
import ButtonComponent from "../../../Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import CloseIcon from "@mui/icons-material/Close";

import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import { UnifiedLongPressableObject } from "components/elements/main/UnifiedLongPressableObject";
import UnifiedPullDown from "components/elements/main/UnifiedPullDown";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import {userMainResetSearchTrackedProducts} from "actions";

const UserProductTrack = (props) => {
  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: false,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
  const [optionValues, setOptionValues] = useState([]);

    const [categoryState, setCategoryState] = useState("");
    const [colorState, setColorState] = useState("");
    const [locationState, setLocationState] = useState("");
    const [marketState, setMarketState] = useState("");
    const [typeState, setTypeState] = useState("viewed");
    const [offsetState, setOffsetState] = useState(0);

    const [loadStoryState, setLoadStoryState] = useState(false);
    const [loadModalState, setLoadModalState] = useState(false);
    const [loadIdState, setLoadIdState] = useState("");
    const [currentStoryIndex, setCurrentStoryIndex] = useState(null);
    const [showModalProduct, setShowModalProduct] = useState(null);

    const [hasTriedLoading, setHasTriedLoading] = useState(false);

    const {
        serviceError, reqStatus, isLoadingProducts,
        userMainResetSearchTrackedProducts,
        userMainGetTrackProductsViewed,
        userMainGetProductInfo,
        products, productdetail, searchkeywords,
        userMainResetProductDetail,
        userMainAddProductToWishlist, getTryOnProfileImage,
        commonCategoryList, commonColorList, citylocations,
        currency, match, history,
        isLoadingShop, shopId, isShop, marketId, limit, wholesale,
        userDetails
    } = props;

  const { keywords } = searchkeywords;

  const {
    resetvalue,
  } = state;

  const { query } = match.params;
  const { type } = match.params;

    const urlparams = useLocation();

    const { categories } = commonCategoryList;

    const closeProductModal = () => setShowModalProduct(null);

    useEffect(() => {

        userMainResetSearchTrackedProducts();

        analyticsTrackPageView("/products/show", "Main Products Show");

        // Get a specific query parameter
        const checkLoadState = new URLSearchParams(urlparams.search).get('ls');

        if (checkLoadState) {
            if (checkLoadState === "1") {
                setLoadStoryState(true);
            } else if (checkLoadState === "2") {
                setLoadModalState(true);
            }
        }

        const loadIndex = new URLSearchParams(urlparams.search).get('li');

        if (loadIndex) {
            setLoadIdState(loadIndex);
        }

        if (type) {
            setTypeState(type);
        }

        setHasTriedLoading(false);

        userMainGetTrackProductsViewed(type);

    }, []);

    useEffect(() => {
        if (!isLoadingProducts && products.length > 0 && loadStoryState) {
            openStoriesView();
            setLoadStoryState(false);
        }
    }, [isLoadingProducts, products, loadStoryState]);

    useEffect(() => {
        if (
            loadModalState &&
            products.length > 0 &&
            loadIdState !== "" &&
            products[loadIdState]
        ) {
            openModalView();
            setLoadModalState(false);
        }
    }, [loadModalState, products, loadIdState]);

  const runSearch = (keyword) => {
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });
    history.push(`/products/search/${keyword}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {

    }
  };

    const debouncedChangeHandler = useCallback(
        debounce(runKeywordSearch, 300)
        , []);

  const selectKeywordSearch = (value) => {
      history.push(`/products/search/${value}`);
  };

  const handleDelete = () => {
      history.push("/products");
  };


    const addProductFavourite = (prodId) => {
        userMainAddProductToWishlist(prodId);
    };


    // Click on product item from search results
  const handleProductView = (mode, product, index, withStory, reset) => () => {

      if (withStory) {
          setLoadIdState(index);
      }

    if (reset) {
      setProductState({
        selectedProduct: {
            _id: "",
            shop_id: "",
            status: "",
            images: [],
            video: [],
            title: "",
            logo: [],
            area: "",
        },
      });
      setProductModeState(mode);
    } else {

        analyticsTrackEvent("User Interaction", "Main Product Clicked : Story - " + withStory, product.title + " " + product.shop_id + " " + product._id);

        userMainGetProductInfo(product._id);
      setProductState({
          selectedProduct: {
            _id: product._id,
              shop_id: product.shop_id,
            status: product.status,
            images: product.images,
            video: product.video,
            title: product.title,
            logo: product.logo,
            area: product.area,
        },
      });

      // Open modal for VIEWDETAIL mode, otherwise set product mode state
      if (mode === "VIEWDETAIL") {
          setShowModalProduct(product);
      } else {
          setProductModeState(mode);
      }
    }
  };

    const handleViewShop = (product, index) => {
        setProductModeState("VIEWDETAIL");
        history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", product.shop_id, "", ""));
    };

    // Click on product item from stories player
    const handleBuyProduct = (product, index) => {

        userMainGetProductInfo(product._id);
        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

        // Open modal instead of changing view mode
        setShowModalProduct(product);
    };

    const openCategoryList = () => {
        setProductModeState("CATEG");
    };

    const openStoriesView = () => {
        setProductModeState("STORIES");
    };

    const openModalView = () => {
        handleModalView(products[loadIdState], loadIdState)();
        setProductModeState("PREVIEW");
    };

  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);

    const handleSortProducts = (event) => {
        setOffsetState(0);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleCategoryProducts = (event) => {
        setCategoryState(event.target.value);
        setOffsetState(0);
        setColorState("");
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleCategorySelect = (cat) => {
        setProductModeState("PREVIEW");
        setOffsetState(0);
        setCategoryState(cat);
        setColorState("");
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };


    const handleSelectCategorySet = (cat) => {
        setOffsetState(0);
        setCategoryState(cat);
        setColorState("");
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleSelectColorSet = (color) => {
        setOffsetState(0);
        setColorState(color);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleLocationSet = (location) => {
        setOffsetState(0);
        setLocationState(location.id);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };


    const setProductStatus = (sort) => {
        setOffsetState(0);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleRestAll = () => {
        setOffsetState(0);
        setLocationState("");
        setCategoryState("");
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handlePrevOffset = () => {
        const offset = offsetState > 1 ? offsetState - 1 : 0;
        setOffsetState(offset);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleNextOffset = () => {
        const offset = offsetState + 1;
        setOffsetState(offset);
        setHasTriedLoading(false);
        userMainGetTrackProductsViewed();
    };

    const handleResetResultsStory = () => {
        setProductModeState("PREVIEW");
        setLoadIdState("");
    };

    const handleResetProductStory = () => {
        setLoadIdState("");
    };

    const handleVisit = () => {
        history.push("/products");
    };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/search")) {
      history.push("/products/search");
    }
  };

  let isModalSearch = false;

    const productsort = getUserProductSortList();

    const sortOptions = productsort.map((item) => {
        const { value, label } = item;
        return (
            <MenuItem value={value}>{label}</MenuItem>
        );
    });

    const categoryFilterOptions = categories.map((item) => {
        const { id, name } = item;
        return (
            <MenuItem value={id}>{name}</MenuItem>
        );
    });

  const renderNoResults = () => (
      <Container>
        <Box>
            <Typography variant="h6">
                No item found
            </Typography>
        </Box>
      </Container>
  );

    const handleModalView = (product, index) => () => {

        userMainResetProductDetail();

        setShowModalProduct(product);

        userMainGetProductInfo(product._id);

        setProductState({
            selectedProduct: {
                _id: product._id,
                shop_id: product.shop_id,
                status: product.status,
                images: product.images,
                video: product.video,
                title: product.title,
                logo: product.logo,
                area: product.area,
            },
        });

    };

  const renderResults = () => (
      <Box sx={{ mt: 2, mb: 4 }}>
          {/*isFeatureSupported("shopreels") &&
              <CustomFlexBox sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'fixed',
                  width: '100%',
                  bottom: 70,
                  justifyContent: 'center',
                  zIndex: 'modal'
              }}>
                  <Button
                      sx={{marginRight: '2px'}}
                      size="large"
                      color="primary"
                      variant="contained"
                      onClick={openStoriesView}
                  >
                      <SlideshowIcon /> &nbsp; View as {process.env.REACT_APP_REELS_TAG}
                  </Button>
              </CustomFlexBox>
          */}

          {<CustomSectionCreator icon={type === "allviewed" ? <NotificationsActiveIcon sx={{ color: '#E53E3E', mr: 1 }} /> : <ViewWeekIcon sx={{ color: '#E53E3E', mr: 1 }} />} title={type === "allviewed" ? "Most Active Products" : "Previously Viewed Products"} seeMoreLinkTitle={"View all"} seeMoreLink={"/products"} />}

          <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
              {products.map((product, index) => (
                  <Grid item key={index} xs={6} sm={3} md={3} lg={3}>
                      <UnifiedLongPressableObject item={product} index={index}
                                                  onLongPress={handleModalView(product, index)}>
                          <UserProductItem
                              product={product}
                              currency={currency}
                              onMainClick={handleModalView(product, index)}
                              onArrowClick={handleProductView("STORIES", product, index, true, false)}
                              onBottomClick={handleModalView(product, index)}
                          />
                      </UnifiedLongPressableObject>
                  </Grid>
              ))}
          </Grid>

          <ButtonComponent
              type="primary"
              variant="contained"
              name="View more..."
              fullWidth
              size="medium"
              onClick={handleVisit}
          />

      </Box>
  );

    const storiesData = products.map((product, index) => {
        const {id, shop_id, images, video, title, logo, area} = product;

        let stories = [];

        if (video && video.length > 0) {
            stories.push({
                video: video[0].cdn.secure_url,
                videoimage: images && images[0].cdn.secure_url
            });
        } else {
            images && images.map((product) => (
                stories.push({
                    image: product.cdn.secure_url,
                })
            ));
        }


        return (
            {
                user: {
                    avatar: getLogo(logo),
                    name: title,
                    linkTitle1: "View Shop",
                    linkTitle2: "Detail",
                    area: area,
                },
                item: product,
                itemIndex: index,
                favId: id,
                stories: stories,
            }
        );
    });

    const renderResultsAsStories = () => (
        <div>
            <StoriesPlayer
                loadIndex={loadIdState}
                storiesData={storiesData}
                setAsFav={addProductFavourite}
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
                onCancel={() => handleResetResultsStory()}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
                onRightSwipeComplete={() => handleBuyProduct(products[currentStoryIndex], currentStoryIndex)}
            />
        </div>
    );

    const renderProductDetail = () => (
        <>
            <UserProductDetail
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={addProductFavourite}
                history={history}
                onCancel={() => setProductModeState("PREVIEW")}
                wholesale={wholesale}
            />
            <UnifiedSwipeTrigger
                onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
            />
        </>
    );

    const renderProductModal = () => (
        <>
            <UserProductDetailModal
                {...props}
                setState={(value, field) => setProductState({
                    ...state,
                    selectedProduct: {
                        ...selectedProduct,
                        [field]: value,
                    },
                })}
                currency={currency}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToFavlistClicked={addProductFavourite}
                history={history}
                onCancel={() => setProductModeState("PREVIEW")}
                excludeHome={wholesale}
                wholesale={wholesale}
            />
        </>
    );

    const renderProductWithStoriesPlayer = (productData) => (

        <div>

            {renderProductDetail()}

            <StoriesPlayer
                storiesData={productData}
                onCancel={() => handleResetProductStory()}
                setAsFav={addProductFavourite}
                onButton1Click={handleViewShop}
                onButton2Click={handleBuyProduct}
                onIndexChange={(index) => setCurrentStoryIndex(index)}
            />
        </div>

    );

  const renderSearchResults = () => (
    <>
      <Container>
      { match.path !== "/"
      && (
          match.path === "/products/show" ||
          match.path === "/products/show/:type"
      ) && (
      <>
          {isLoadingProducts ? (
              <MockSearchResults />
          ) : products.length > 0 ? (
              renderResults()
          ) : hasTriedLoading ? (
              renderNoResults()
          ) : null}
      </>
      )}
      </Container>
    </>
  );

  const renderProductMode = (productMode) => {
    switch (productMode) {

        case "STORIES":
            return renderResultsAsStories();

        case "CATEG":
            return (
        <MobileCategoryNav
            categories={categories}
            categoryState={categoryState}
            selectCategoryClicked={handleCategorySelect}
        />
            );

        case "STORIESVIEW":

            const {id, shop_id, images, video, title, logo, area} = selectedProduct;

            let productStoryData = [];
            let stories = [];

            if (video && video.length > 0) {
                stories.push({
                    video: video[0].cdn.secure_url,
                    videoimage: images && images[0].cdn.secure_url
                });
            } else {
                images && images.map((product) => (
                    stories.push({
                        image: product.cdn.secure_url,
                    })
                ));
            }


            productStoryData.push(
                {
                    user: {
                        avatar: logo[0].cdn.secure_url,
                        name: title,
                        linkTitle1: "View Shop",
                        linkTitle2: "Detail",
                        area: area,
                    },
                    favId: shop_id,
                    stories: stories,
                }
            );

            return renderProductWithStoriesPlayer(productStoryData);

        case "VIEWDETAIL":
            return renderProductDetail();

        case "PREVIEW":
        default:
            return renderSearchResults();
    }
  };

  const { selectedProduct = {} } = productState;

  return (
      <Container>
        {renderProductMode(productModeState)}

          <Modal
              open={!!showModalProduct}
              onClose={closeProductModal}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{ timeout: 300 }}
          >
              <Fade in={!!showModalProduct}>
                  <Box>
                      <IconButton
                          onClick={closeProductModal}
                          sx={{
                              position: 'absolute',
                              top: '2%',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              zIndex: 1301,
                              backgroundColor: 'black',
                              color: 'white',
                              width: 48,
                              height: 48,
                              pointerEvents: 'auto',
                              '&:hover': {
                                  backgroundColor: 'grey.800',
                              },
                          }}
                      >
                          <CloseIcon />
                      </IconButton>
                      <Box
                          sx={{
                              position: 'absolute',
                              top: '8%',
                              height: '95%',
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                          }}
                      >
                          {/* checking showModalProduct._id === selectedProduct._id avoids race condition */}
                          {showModalProduct && selectedProduct && showModalProduct._id === selectedProduct._id && (
                              <>
                                  <Box sx={{
                                      position: 'absolute',
                                      top: '50%',
                                      left: '50%',
                                      transform: 'translate(-50%, -50%)',
                                      width: '96%',
                                      height: '95%',
                                      overflow: 'auto',
                                      boxSizing: 'border-box',
                                      bgcolor: 'background.paper',
                                      borderRadius: 2,
                                      boxShadow: 24,
                                      p: 2,
                                  }}>
                                      <UnifiedPullDown onPullDown={closeProductModal} threshold={60}>
                                          {renderProductModal()}
                                      </UnifiedPullDown>
                                  </Box>
                                  <UnifiedSwipeTrigger
                                      onLeftSwipeComplete={() => { closeProductModal(); setProductModeState("PREVIEW"); }}
                                      onRightSwipeComplete={() => { closeProductModal(); history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", selectedProduct.shop_id, "", "")); }}
                                  />
                              </>
                          )}
                      </Box>
                  </Box>
              </Fade>
          </Modal>
      </Container>
  );


};

UserProductTrack.defaultProps = {
  currency: "",
};

UserProductTrack.propTypes = {
    currency: PropTypes.string,
    bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    products: PropTypes.arrayOf(PropTypes.any).isRequired,
    searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    commonCategoryList: PropTypes.objectOf(PropTypes.any).isRequired,
    commonColorList: PropTypes.objectOf(PropTypes.any).isRequired,
    citylocations: PropTypes.objectOf(PropTypes.any).isRequired,
    userMainSearchProducts: PropTypes.func.isRequired,
    userMainSearchKeywords: PropTypes.func.isRequired,
    userMainResetsearchKeywords: PropTypes.func.isRequired,
    userMainResetSearchProducts: PropTypes.func.isRequired,
    userMainGetProductInfo: PropTypes.func.isRequired,
    userMainAddProductToWishlist: PropTypes.func.isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const userProductTrack = connect(
  ({ userMainProducts, bootupInfo, userMainShops, userbootupInfo }) => ({
      bootupInfo,
      userbootupInfo,
      userDetails: bootupInfo.userDetails,
      currency: bootupInfo.symbol,
      reqStatus: userMainProducts.reqStatus,
      isLoadingProducts: userMainProducts.isLoading,
      serviceError: userMainProducts.serviceError,
      products: userMainProducts.trackproductsviewed,
      searchkeywords: userMainProducts.searchkeywords,
      searchcategorykeywords: userMainProducts.searchcategorykeywords,
      commonCategoryList: userMainProducts.categoryList,
      commonColorList: userMainProducts.colorList,
      citylocations: bootupInfo.citylocations,
      productdetail: userMainProducts.productdetail,
      shopDetail: userMainShops.shopDetail,
      isLoadingShop: userMainShops.isLoading,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserProductTrack);

export { userProductTrack as default };
